<script setup lang="ts">
import { ref, computed } from 'vue'
import { Eye, EyeOff } from 'lucide-vue-next'

const props = defineProps<{
  modelValue: string
  label: string
  placeholder?: string
  required?: boolean
  inputRef?: any
  autocomplete?: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const showPassword = ref(false)

const localValue = computed({
  get: () => props.modelValue,
  set: (val: string) => emit('update:modelValue', val)
})
</script>

<template>
  <div class="space-y-1">
    <label class="block text-[11px] font-bold text-gray-400 ml-2">{{ label }}</label>
    <div class="relative">
      <input
        :ref="inputRef"
        v-model="localValue"
        :type="showPassword ? 'text' : 'password'"
        :placeholder="placeholder"
        :autocomplete="autocomplete || 'off'"
        class="w-full px-5 py-2.5 bg-[#F8FAFF] border border-gray-100 rounded-[12px] text-[13px] focus:bg-white transition-all outline-none placeholder:text-gray-300"
        :required="required"
      />
      <button
        type="button"
        @click="showPassword = !showPassword"
        class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-300 hover:text-gray-500 transition-colors"
      >
        <EyeOff v-if="showPassword" :size="16" />
        <Eye v-else :size="16" />
      </button>
    </div>
  </div>
</template>
